import { Component, h, Host, Prop, ComponentInterface } from '@stencil/core';

@Component({
  tag: 'signet-header-group',
})
export class SignetHeaderGroup implements ComponentInterface {
  @Prop() position: 'left' | 'right' | 'center' = 'right';

  render() {
    return (
      <Host class={`header-group align-${this.position}`}>
        <slot />
      </Host>
    );
  }
}
